// NOTE: The whole file should be renamed to contain user's preferences.
export function data_sources(state = [], action) {
  switch (action.type) {
    case 'DATA_SOURCE_DISCONNECT':
      return state.map(ds => {
        if (ds.id === action.payload) {
          return {
            ...ds,
            connected: false,
            last_synced_at: null,
            authorization: null,
          };
        }
        return ds;
      });
    default:
      return state;
  }
}

export function notification_destinations(state = [], action) {
  switch (action.type) {
    case 'NOTIFICATION_DESTINATIONS_GET_RESPONSE':
    case 'NOTIFICATION_DESTINATION_ENABLE_RESPONSE_SUCCESS':
    case 'NOTIFICATION_DESTINATION_DISABLE_RESPONSE_SUCCESS':
      return action.payload.notification_destinations;
    case 'UPDATE_NOTIFICATION_DESTINATION_SETTINGS_REQUEST':
      return state.map(notification_destination => {
        if (notification_destination.id === action.payload.notificationDestinationID) {
          return { ...notification_destination, settings: action.payload.settings };
        }

        return notification_destination;
      });
    default:
      return state;
  }
}

export function web_notifications(state = [], action) {
  switch (action.type) {
    case 'NOTIFICATIONS_READ_RESPONSE':
    case 'NOTIFICATIONS_GET_RESPONSE':
      return action.payload.web_notifications;
    case 'NOTIFICATION_READ_RESPONSE':
      return state.map(notification => {
        if (notification.id === action.payload.id) return { ...notification, ...action.payload };
        return notification;
      });
    case 'NOTIFICATIONS_SYNC':
      return [
        ...state.filter(({ id }) => !action.payload.find(notification => id === notification?.id)),
        ...action.payload,
      ];
    default:
      return state;
  }
}
